import { useState, useEffect } from 'react';

const axios = require('axios').default;

export default function useMemberships({ team, contact, csrfToken, enabled = true }) {
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!enabled) return undefined;
    if (!team || !contact || !contact.id) return undefined;

    let ignore = false;
    const fetchMemberships = async () => {
      try {
        setLoading(true);
        setError('');
        if (csrfToken) {
          axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
        }

        const response = await axios.get(
          `/teams/${team.id}/crm/fans/${contact.id}/memberships.json`,
        );
        if (ignore) return;
        const data = response.data || {};
        setMemberships(data.memberships || []);
        setLoaded(true);
      } catch (err) {
        if (!ignore) setError('Failed to load memberships');
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    fetchMemberships();
    return () => { ignore = true; };
  }, [team, contact, csrfToken, enabled]);

  return { memberships, loading, loaded, error };
}
